import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Calendar } from "lucide-react";
import { getAllExamsPortal } from "../../api/examsschedule/examPortalApi";
import { getAllExams } from "../../api/examsschedule/examApi";
import { getActiveAcademicYearPortal } from "../../api/academic/academicYearPortalApi";
import { getActiveAcademicYear } from "../../api/academic/academicYearApi";
import { pickList, toId } from "../../utils/examsschedule/examHelpers";
import ExamStatusBadge from "../examsschedule/ExamStatusBadge";
import WidgetCard from "../widget/WidgetCard";

const resolveYearName = (res) => {
  if (!res) return "";
  const y = res.academicYear || res.data || res;
  if (typeof y === "string") return y.trim();
  return (y.yearName || y.name || y.academicYear || y.label || "").toString().trim();
};

export const ExamWidget = ({ isPortal = false }) => {
  const navigate = useNavigate();
  const [exams, setExams] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        setLoading(true);
        const yearRes = isPortal ? await getActiveAcademicYearPortal() : await getActiveAcademicYear();
        const activeYearName = resolveYearName(yearRes);

        const res = isPortal
          ? await getAllExamsPortal({ academicYear: activeYearName })
          : await getAllExams({ academicYear: activeYearName });

        if (!cancelled) {
          const list = pickList(res, ["exams", "data"]);
          const filteredExams = list.filter(
            (exam) => exam.status === "DRAFT" || exam.status === "PUBLISHED" || exam.status === "IN_PROGRESS"
          );
          setExams(filteredExams.slice(0, 5));
        }
      } catch (err) {
        console.error("Failed to load exam widget data", err);
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [isPortal]);

  const basePath = isPortal ? "/staff-panel/exam/exams" : "/exam/exams";

  return (
    <WidgetCard
      title="Upcoming & Active Examinations"
      icon={Calendar}
      loading={loading}
      empty={!loading && exams.length === 0}
      emptyText="No upcoming or active exams found."
      onViewAll={() => navigate(basePath)}
    >
      <div className="space-y-2">
        {exams.map((exam) => (
          <div
            key={toId(exam)}
            onClick={() => navigate(`${basePath}/${toId(exam)}`)}
            className="flex items-center justify-between gap-3 rounded-xl border border-slate-200/80 bg-gradient-to-r from-slate-50/50 to-white px-3.5 py-2.5 transition-all duration-200 hover:border-indigo-300 hover:shadow-xs cursor-pointer"
          >
            <div className="min-w-0 flex-1">
              <p className="truncate text-xs font-bold text-slate-800 dark:text-neutral-100">{exam.name}</p>
              {exam.academicYear && (
                <p className="truncate text-[11px] font-semibold text-indigo-600 mt-0.5">
                  {exam.academicYear}
                </p>
              )}
            </div>
            <div className="shrink-0">
              <ExamStatusBadge status={exam.status} />
            </div>
          </div>
        ))}
      </div>
    </WidgetCard>
  );
};